// extracted by mini-css-extract-plugin
export default {"stuffOptionSelection":"StuffOptionSelection_stuffOptionSelection__rHS0Y"};